import { databases } from "@/lib/appwrite";
import { ID } from "appwrite";

export type CertificateType = 'standard' | 'with_salary' | 'job_functions';

interface CreateCertificateRequestParams {
    userId: string;
    reason: string;
    type: CertificateType;
}

export const createCertificateRequest = async ({
    userId,
    reason,
    type
}: CreateCertificateRequestParams) => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        if (!databaseId || !collectionId) {
            throw new Error("Missing environment variables for database or collection");
        }

        const currentDate = new Date().toISOString();

        const response = await databases.createDocument(
            databaseId,
            collectionId,
            ID.unique(),
            {
                userId,
                reason,
                type,
                requestDate: currentDate,
                status: "pending",
                statusByRrhh: "pending",
                statusByManager: "pending",
                statusBySupervisor: "pending",
                approvedAt: null,
                commentsRrhh: null,
                commentsManager: null,
                certificateFileId: null
            }
        );

        return {
            success: true,
            data: response
        };
    } catch (error) {
        console.error("Error creating certificate request:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Unknown error occurred"
        };
    }
};

export const updateCertificateFileId = async (
    requestId: string,
    fileId: string
) => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        await databases.updateDocument(
            databaseId,
            collectionId,
            requestId,
            {
                certificateFileId: fileId
            }
        );

        return { success: true };
    } catch (error) {
        console.error("Error updating certificate file ID:", error);
        return { success: false };
    }
};